export const formatAddressesFromLookup = (addresses) =>
  addresses.map((address, key) => ({
    ...address,
    key,
  }));
